import { AnimatePresence, motion } from "framer-motion";
import { LOCATIONS, fullAddress } from "@/content/locations";

const embedUrl = (l) => `https://www.google.com/maps?q=${encodeURIComponent(`${l.name}, ${fullAddress(l)}`)}&z=15&output=embed`;

export const LocationMap = ({ active, onSelect, className = "", showPicker = true }) => {
  const loc = LOCATIONS.find((l) => l.slug === active) || LOCATIONS[0];
  return (
    <div data-testid="location-map" className={`relative overflow-hidden rounded-[2rem] bg-[#e9dfd2] ${className}`}>
      <AnimatePresence initial={false}>
        <motion.iframe
          key={loc.slug}
          title={`Google Map — ${loc.name}, ${fullAddress(loc)}`}
          src={embedUrl(loc)}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          data-testid={`google-map-${loc.slug}`}
          className="absolute inset-0 h-full w-full border-0"
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
        />
      </AnimatePresence>
      {showPicker && (
        <div className="no-scrollbar absolute inset-x-3 bottom-8 flex gap-2 overflow-x-auto rounded-full bg-[#fff5e8]/90 p-1.5 shadow-xl backdrop-blur-xl">
          {LOCATIONS.map((l, i) => {
            const on = l.slug === loc.slug;
            return (
              <button key={l.slug} type="button" onClick={() => onSelect?.(l.slug)} data-testid={`map-pin-${l.slug}`} className={`relative flex shrink-0 items-center gap-2 rounded-full py-1.5 pl-1.5 pr-3 font-display text-xs font-bold uppercase tracking-wide transition-colors duration-300 ${on ? "bg-[#1a0a10] text-[#fff5e8]" : "text-[#1a0a10] hover:bg-[#1a0a10]/10"}`}>
                <span className="tea-pin !h-6 !w-6" style={{ "--pin": l.color }}>
                  {on && <span className="pulse" />}
                  <span className="dot !inset-0 !border-2 !text-[10px]">{i + 1}</span>
                </span>
                {l.city}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
